module.exports = __webpack_public_path__ + "9ffb763f3b9f3ae600c5a42883c1b5f9.svg";